import Router, {Resource} from 'tg-resources';
import reverseUrl from 'utils/urls';
import {getCookie} from 'utils/cookie';


/* eslint-disable no-template-curly-in-string */
const basketDetailsUrl = reverseUrl('basket-detail', 0).replace('/0/', '/${pk}/');
const basketLinesUrl = reverseUrl('basket-lines-list', 0).replace('/0/', '/${pk}/');
const productDetailsUrl = reverseUrl('product-detail', 0).replace('/0/', '/${pk}/');
const lineDetailUrl = reverseUrl('basket-line-detail', 0, 1)
                                                        .replace('/0/', '/${basketId}/').replace('/1/', '/${lineId}/');
const searchUrl = reverseUrl('api-search');

/* eslint-enable */

const api = new Router({
    categoryList: new Resource(reverseUrl('category-list')),
    userBasketDetails: new Resource(reverseUrl('api-basket')),
    basketDetails: new Resource(basketDetailsUrl),
    basketLines: new Resource(basketLinesUrl),
    productDetails: new Resource(productDetailsUrl),
    basketAddProductUrl: new Resource(reverseUrl('api-basket-add-product')),
    basketShippingMethods: new Resource(reverseUrl('api-basket-shipping-methods')),
    lineDetail: new Resource(lineDetailUrl),
    search: new Resource(searchUrl),
}, {
    apiRoot: DJ_CONST.SITE_URL,
    headers: () => ({
        Accept: 'application/json',
        'X-CSRFToken': getCookie('csrftoken'),
    }),
});

export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js